global.jQuery = global.$ = window.jQuery = require('jquery');
require('jquery.easing');
require('jquery.color');
require('jquery.inview');
require('swiper');
require('images-compare');
require('slick');


/*--------------------------------------------------------------------------*
 * ポップアップウィンドウ
 *
 * jquery.openwin.js
 * http://shanabrian.com/web/jquery/window01.php
 *
 * 下記の様にhtml側のrel要素で個別にオプション指定も可。
 * <a href="" class="openwin" rel="scrollbars=yes,target=_self,blur=true">hoge</a>
 *--------------------------------------------------------------------------*/

$(function () {
    $.fn.openwin = function (settings) {
        settings = $.extend({
            option: {
                width: false,
                height: false,
                top: false,
                left: false,
                menubar: 'no',
                toolbar: 'no',
                location: 'no',
                status: 'no',
                resizable: 'no',
                scrollbars: 'no',
                directories: 'no',
                titlebar: 'yes',
                fullscreen: 'no'
            },
            target: '_blank',
            blur: false,
            focus: false
        }, settings);

        $(this).on('click', function () {
            var options = [];
            var target = settings.target;
            var url = $(this).attr('href');

            if ($(this).attr('rel')) {
                var rel = $(this).attr('rel').split(',');
                var relOption = {};
                $.each(settings.option, function (i, rel) {
                    var a = rel[i].split('=');
                    relOption[a[0]] = a[1];
                });
            }

            $.each(settings.option, function (k) {
                var v = settings.option[k];
                if (relOption) {
                    if (relOption[k]) {
                        v = relOption[k];
                    }
                }
                if (v) {
                    options.push(k + '=' + v);
                }
            });
            if (relOption) {
                if (relOption['target']) {
                    target = relOption['target'];
                }
            }
            var newWin = window.open(url, target, options.join(','));
            if (settings.blur === true) {
                newWin.blur();
            }
            if (settings.focus === true) {
                newWin.focus();
            }
            return false;
        });
        return this;
    };
});


$(function () {
    // ポップアップウィンドウの設定
    $('a.openwin').openwin({
        option: {
            width: 1000,
            height: 900,
            top: false,
            left: false,
            menubar: "no",
            toolbar: "no",
            location: "no",
            status: "no",
            resizable: "yes",
            scrollbars: "yes",
            directories: "no",
            titlebar: "yes",
            fullscreen: "no"
        }
    });
});

$(function () {

    /*--------------------------------------------------------------------------*
     * menu
     *--------------------------------------------------------------------------*/



    var px_change = $('.header__inner').innerHeight();

    window.addEventListener('scroll', function (e) {
        if ($(window).scrollTop() > px_change) {
            $('.nav-global').addClass('fixed');
            $('.c-info').addClass('fixed');
        } else if ($('.nav-global').hasClass('fixed')) {
            $('.nav-global').removeClass('fixed');
            $('.c-info').removeClass('fixed');
        }
    });

    var flag = false;
    var $navGlobal = $('.gnav__sp');
    var $humberger = $('.humberger');
    var $gnavBtn = $('.gnav__link');

    $humberger.on('click', function () {
        if (!flag) {
            $humberger.addClass('active');
            $navGlobal.fadeIn(function () {
                flag = true;
            });
        } else {
            $humberger.removeClass('active');
            $navGlobal.fadeOut(function () {
                flag = false;
            });
        }
    });
    $gnavBtn.on('click', function () {
        
            $humberger.removeClass('active');
            $navGlobal.fadeOut(function () {
                flag = false;
            });
    });
	$(window).on('load resize', function(){
		var windowWidth = $(window).innerWidth();
		if( windowWidth > 992 ){
			$humberger.removeClass('active');
            $navGlobal.fadeOut(function () {
                flag = false;
            });
		}
	});
    

    


    /*--------------------------------------------------------------------------*
     * スムーズスクロール
     *--------------------------------------------------------------------------*/
    $('a[href^="#"]').click(function () {
        var speed = 500;
        var href = $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        var position = target.offset().top;
        $("html, body").animate({
            scrollTop: position
        }, speed, "swing");
        return false;
    });


    $('body').on("mousewheel", function () {
        event.preventDefault();
        var wd = event.wheelDelta;
        var csp = window.pageYOffset;
        window.scrollTo(0, csp - wd);
    });
    /*--------------------------------------------------------------------------*
     * inveiw
     *--------------------------------------------------------------------------*/

    $('.inviewset').css('opacity', '0');
    $('.content_bg').css('opacity', '1');

    $('.inviewset').on('inview', function () {
        $(this).delay(300).animate({
            opacity: '1'
        }, 700);
    });
    $('.content_bg').on('inview', function () {
        $(this).addClass('content_bg-acitve');
    });

    $('.inviewchain01').css('opacity', '0');
    $('.inviewchain02').css('opacity', '0');
    $('.inviewchain03').css('opacity', '0');
    $('.inviewchain04').css('opacity', '0');
    $('.inviewchain05').css('opacity', '0');
    $('.inviewchain06').css('opacity', '0');

    $('.inviewchainwrap').on('inview', function () {
        $(this).find('.inviewchain01').delay(300).animate({
            opacity: '1'
        }, 600);
        $(this).find('.inviewchain02').delay(600).animate({
            opacity: '1'
        }, 600);
        $(this).find('.inviewchain03').delay(900).animate({
            opacity: '1'
        }, 600);
        $(this).find('.inviewchain04').delay(1200).animate({
            opacity: '1'
        }, 600);
        $(this).find('.inviewchain05').delay(1500).animate({
            opacity: '1'
        }, 600);
        $(this).find('.inviewchain06').delay(1800).animate({
            opacity: '1'
        }, 600);
    });



    /*--------------------------------------------------------------------------*
     * images-compare
     *--------------------------------------------------------------------------*/

    $('.index-section03__element-compare01').imagesCompare();
    $('.index-section03__element-compare02').imagesCompare();




    /*--------------------------------------------------------------------------*
     * slick
     *--------------------------------------------------------------------------*/

    $('.index__mvimg').slick({
        autoplay: true,
        arrows:false,
        autoplaySpeed: 5000,
        fade: true,
        speed:1000
    });
    
    /*--------------------------------------------------------------------------*
     * ロゴ固定
     *--------------------------------------------------------------------------*/
//    var headNav = $(".gnav__pc .logo");
//	//scrollだけだと読み込み時困るのでloadも追加
//	$(window).on('load scroll', function () {
//		//現在の位置が500px以上かつ、クラスfixedが付与されていない時
//		if($(this).scrollTop() > 600 && headNav.hasClass('fixed') == false) {
//			//headerの高さ分上に設定
//			headNav.css({"top": '-100px'});
//			//クラスfixedを付与
//			headNav.addClass('fixed');
//			//位置を0に設定し、アニメーションのスピードを指定
//			headNav.animate({"top": 0},650);
//		}
//		//現在の位置が600px以下かつ、クラスfixedが付与されている時にfixedを外す
//		else if($(this).scrollTop() < 650 && headNav.hasClass('fixed') == true){
//			headNav.removeClass('fixed');
//		}
//	});
    
	var TopBtn = $('.gnav__pc .logo');
	TopBtn.hide();
	// スクロール位置が750でボタンを表示
	$(window).scroll(function () {
		if ($(this).scrollTop() > 750) {
			TopBtn.fadeIn();
		} else {
			TopBtn.fadeOut();
		}
	});
	// ボタンを押下するとトップへ移動
	//    TopBtn.click(function() {
	//        $('body,html').animate({
	//            scrollTop: 0
	//        }, 300);
	//        return false;
	//    });




});

/*--------------------------------------------------------------------------*
 * スクローラー設定
 *--------------------------------------------------------------------------*/
var isMobile = false;
isMobile = $('html').is('.skrollr-mb');
if (!isMobile) {
    window.onload = function () {
        var s = skrollr.init({
            forceHeight: false,
            mobileDeceleration: 0.01,
            mobileCheck: function () {
                return isMobile;
            }
        });
    }
}
